import { Device_Type } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/device_pb.ts';
import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

const DEVICES_PAGE_SIZE = BigInt(1000);

export const listDevices = async () =>
  await blazeDevicePromiseClient.listDevices({
    pageSize: DEVICES_PAGE_SIZE,
    typeFilter: Device_Type.SENTIO_CCU,
  });
